import { makeApiCall, makeFormApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET POST AUDITING TOOL REPORT START *********************** */
export const postAuditingToolReportListGet = (listData: any) => {
	const data = {
		GetPostAuditingToolReportToken: listData,
	};
	const url = `${API_URL}GetPostAuditingToolReport`;
	return makeApiCall(url, data);
};
/** ***************** GET POST AUDITING TOOL REPORT START *********************** */

/** ***************** FETCH POST AUDITING TOOL REPORT EXCEL DETAILS START *********************** */
export const postAuditingToolReportExcelListGet = (listData: any) => {
	const params = new URLSearchParams();
	params.append('FetchPostAuditingToolReportToken', listData);
	const url = `${API_URL}Excel/PostAuditingToolReportExportToken.php`;
	return makeFormApiCall(url, params);
};
/** ***************** FETCH POST AUDITING TOOL REPORT EXCEL DETAILS START *********************** */
